<template>
	<div class="mb-3">
		<label class="form-label small">{{ item.label }}</label>
		<select :value="item.value" @input="updateValue" class="form-select form-select-sm">
			<option value="">{{ item.placeholder || `All ${item.label.toLowerCase()}` }}</option>
			<option v-for="option in item.options" :key="option.id || option.value" :value="option.id || option.value">
				{{ option.name || option.label }}
			</option>
		</select>
	</div>
</template>

<script>
export default {
	name: 'SelectItem',
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
	methods: {
		updateValue(event) {
			this.$emit('update', event.target.value)
		},
	},
}
</script>
